import { SVGProps } from 'react';

const Ready = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M17.867 3h.006q.646 0 1.108.462t.462 1.107q0 .646-.462 1.108a1.5 1.5 0 0 1-1.108.462h-.006zM17.867 7.15h1.726q.538 0 .914.376t.376.913v5.375h-1.505v6.235h-1.511zM17.867 3h-.007q-.646 0-1.107.462a1.5 1.5 0 0 0-.463 1.107q0 .646.463 1.108a1.5 1.5 0 0 0 1.107.462h.007zM17.867 7.15H16.14q-.537 0-.914.376-.375.376-.376.913v5.375h1.505v6.235h1.512zM11.711 4h-5.2c-.662 0-1.214.421-1.425 1.013L3 11.021v8.025l.003 1.003h2.0060000000000002c-.003-.049-.003-1.003-.003-1.003v-1.003h6.705v-2.006H5.006V11.02h6.705V9.126H5.778l1.084-3.12h4.85z"
    />
    <path
      fill="currentColor"
      d="M6.764 13.655a1.128 1.128 0 1 1 2.257 0 1.128 1.128 0 0 1-2.257 0"
    />
  </svg>
);
export default Ready;
